/**
 * Chart documentation shown behind the info icon on the SkadNetwork dashboard.
 *
 * Keys match the table link property names in `MopaSkadNetworkComponent`.
 */
export const MopaSkadNetworkChartDocs = {
    mastertable: /* HTML */ `<p>
            SKAdNetwork postbacks by conversion value, grouped by the applied
            splits - by default network, campaign and postback date.
        </p>
        <p>
            <strong>Columns:</strong> one per conversion value, 0-63 plus NULL,
            holding the number of postbacks carrying that value;
            <strong>&lt;&gt; 0</strong> sums 1-63, leaving out both 0 and NULL.
            The "Selected metrics" setting picks which of them are shown.
        </p>
        <p>
            Rows use <strong>postback date, not install date</strong>. Apple
            releases each postback at a delay after the measurement window
            closes, so one row mixes installs from several earlier days and
            recent dates keep filling in afterwards.
        </p>
        <p>
            The <strong>Source</strong> filter separates the postback feeds;
            keep all of them selected for a total.
        </p>
        <p>
            Source: <code>bi_stg.skan_decoded_postbacks</code> - SKAdNetwork
            postbacks carry no player identity, so no validation filter applies.
        </p>`,
} as const;
